import React, { Component } from "react";
import TopBar from "../../components/TopBar/TopBar";
import { Switch, Route, Link, withRouter } from "react-router-dom";
import SideNavBar from "../SideNavBar/SideNavBar";
import _ from "lodash";
import Basicform from "../../components/BasicForm/Basicform";
import ForgotPassword from "../../components/Login/ForgotPassword/ForgotPassword";
import VerifyResetPass from "../../components/Login/ForgotPassword/VerifyResetPass";
import ResetPassword from "../../components/Login/ForgotPassword/ResetPassword";
import NotificationBar from "../../components/Common/NotificationBar/index";
import { timpsRoutes, lampRoutes, liteRoutes } from "routes/routes.js";
import SocketIO from "containers/SocketIOContainer";
import { sidebarWidth, sidebarWidthSmall } from "../../components/Common/Variables/CommonVariables";
import Diagnostics from "../../components/diagnostics/index";
import LoginContainer from "../../containers/LoginContainer";
import Logout from "../../containers/LogOutContainer";
import FloatingNavigation from "../../components/Common/FloatingNavigation/index";
import { themeService } from "theme/service/activeTheme.service";
//import Test from 'components/TestComponent/test'
// import Data from 'components/data/data'
import { getServerEndpoint } from "utils/serverEndpoint";

import { tabTitle } from "../../config/tabConfig";
import VersionManager from "./VersionManager.jsx";
import { replaceWithLiteColors, updateThemeColors } from "../../style/basic/basicColors";
import { LocPrefixService } from "../LocationPrefixEditor/LocationPrefixService";
import { isFraRole } from "./UserInfo.js";
import MicrosoftRedirectPage from "../Login/MicrosoftRedirect/MicrosoftRedirectPage.jsx";
import { versionInfo } from "./VersionInfo.js";
import SpinnerLoader from "../Common/SpinnerLoader.js";
import MainPageSpinner from "./MainPageSpinner/MainPageSpinner.jsx";
import { iconCustomizer } from "../Reports/variables.js";
import { CRUDFunction } from "../../reduxCURD/container.js";
import { curdActions } from "../../reduxCURD/actions.js";
import { getUserFromToken } from "../../reduxRelated/actions/userActions.js";
import { sessionService } from "../../services/session.js";
const routeComponent = timpsRoutes.map((route, index) => {
  return <Route key={route.path} path={route.path} component={route.component} />;
});

class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarVisible: false,
      topBarVisible: true,
      userLoggedOn: false,
      routes: [],
      user: "",
      isCheckedIn: false,
      attendanceBtnTxt: "",
      userSession: {},
      currentAttendance: {},
      sessionTime: 0,
      lastSession: 0,
      showTimer: true,
      showSideNav: true,
      language: "en",
      theme: localStorage.getItem("theme"),
      rightValue: "-20%",
      // routeComponent: timpsRoutes.map((route, index) => {
      //   return <Route key={route.path} path={route.path} component={route.component} />;
      // }),
      routesToLoad: timpsRoutes,
      hideNav: window.innerWidth,
      sidebarWidth: sidebarWidth,
      textDisplay: "inline-flex",
      sideNavDispaly: "0px",
      hideToolTip: window.innerWidth <= 760,
      mainSectionLeft: this.isLoggedOn() ? sidebarWidth : 0,
      applicationType: null,
      featureset: [],
      isFra: isFraRole(),
      tempUser: null,
    };
    this.AttendanceBtnHandler = this.AttendanceBtnHandler.bind(this);
    // this.languageChanged = this.languageChanged.bind(this);
    // this.themeChanged = this.themeChanged.bind(this);
    this.sidebarToggle = this.sidebarToggle.bind(this);
    this.toggleRight = this.toggleRight.bind(this);
    this.versionLoaded = this.versionLoaded.bind(this);
    this.expireSession = this.expireSession.bind(this);
    //this.updateThemeColors = this.updateThemeColors.bind(this);
    // console.log(routePath)
  }

  isLoggedOn = () => localStorage.getItem("access_token") !== null;
  loggedInUser = () => localStorage.getItem("loggedInUser");
  isApp = () => localStorage.getItem("source") !== null;
  isMobileSessionActive = () => this.isApp() && sessionService.getToken() && localStorage.getItem("mobile_session_version") !== null;

  AttendanceBtnHandler() {
    if (this.state.isCheckedIn) {
      let checkOutStatus = "Web";
      let checkOutTime = new Date();
      this.props.onCheckOut({
        checkOutStatus: checkOutStatus,
        checkOutTime: checkOutTime,
        attendanceId: this.state.currentAttendance._id,
      });
    } else {
      let checkInStatus = "Web";
      let checkInTime = new Date();
      this.props.onCheckIn({
        checkInStatus: checkInStatus,
        checkInTime: checkInTime,
      });
    }
  }

  componentWillMount() {
    //themeService("retro");

    const { search, pathname } = window.location;

    tabTitle();
    localStorage.setItem("theme", this.state.theme);
    let lang = localStorage.getItem("language");
    if (!lang) {
      localStorage.setItem("language", this.state.language);
    }

    if (this.isLoggedOn()) {
      let user = localStorage.getItem("loggedInUser");
      this.setState({ user: user });
    } else if (
      !this.props.history.location.pathname.includes("confirmreset") &&
      !this.props.history.location.pathname.includes("resetPassword") &&
      !this.props.history.location.pathname.includes("appReport") &&
      !this.props.history.location.pathname.includes("appHos") &&
      !this.isApp() &&
      !pathname.includes("microsoftRedirect")
    ) {
      this.props.history.push(`/login`);
    }
    if (this.isApp()) {
      let isSessionActive = this.isMobileSessionActive();
      if (pathname.length === 0) {
        sessionService.clearSessionStorage();
        this.props.history.push("/appSessionExpire");
      }
      //if session is valid then redirect to url else show expired session page
      if (isSessionActive) this.props.history.push(pathname);
      else this.props.history.push("/appSessionExpire");
    }
    //console.log('MainPage.componentWillMount');
  }

  componentDidMount() {
    // whenever the pages is reloaded, populate the latest Prefix List
    LocPrefixService.populatePrefixList();
    if (this.isLoggedOn()) {
      this.setState({
        sidebarVisible: true,
        topBarVisible: true,
        userLoggedOn: this.isLoggedOn(),
        hamBurgerVisible: this.isLoggedOn(),
      });
    } else {
      this.setState({
        sidebarVisible: false,
        topBarVisible: true,
        userLoggedOn: this.isLoggedOn(),
        hamBurgerVisible: this.isLoggedOn(),
      });
    }
    if (this.isMobileSessionActive()) {
      this.props.getUserFromToken();
    }
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  componentDidUpdate(prevProps) {
    const { userActionType, tempUser } = this.props;
    if (userActionType !== prevProps.userActionType && userActionType === "USER_GET_SUCCESS_TOKEN") {
      this.setState({ tempUser });
    }
  }
  resize() {
    let currentHideNav = window.innerWidth <= 760;
    if (currentHideNav !== this.state.hideNav) {
      this.setState({ hideNav: currentHideNav, hideToolTip: currentHideNav });
      if (currentHideNav) {
        this.setState({ sidebarWidth: sidebarWidthSmall, textDisplay: "none", mainSectionLeft: sidebarWidthSmall });
      } else if (this.isApp()) {
        this.setState({ sidebarWidth: "0px", textDisplay: "none", mainSectionLeft: "0px" });
      } else {
        this.setState({ sidebarWidth: sidebarWidth, textDisplay: "inline-flex", mainSectionLeft: sidebarWidth });
      }
    }
  }
  sidebarToggle() {
    //let el = document.getElementById("sideNav");
    //let toggleVal = window.getComputedStyle(el).getPropertyValue("left");
    this.resize();
    if (this.state.showSideNav) {
      this.setState({ showSideNav: false, mainSectionLeft: "0px" });
    } else {
      this.setState({ showSideNav: true, mainSectionLeft: this.state.sidebarWidth });
      console.log();
    }
  }
  toggleRight() {
    //console.log(this.state.rightValue);
    if (this.state.rightValue == "-20%") {
      this.setState({ rightValue: "0px" });
    } else {
      this.setState({ rightValue: "-20%" });
    }
  }
  expireSession() {
    let isSessionActive = this.isMobileSessionActive();

    if (isSessionActive) {
      sessionService.clearSessionStorage();
      window.location.replace("/appSessionExpire");
    }
  }
  // languageChanged(lang) {
  //   let renderResult = routePath.map((route, index) => {
  //     return <Route key={route.path} path={route.path} component={route.component} />;
  //   });
  //   this.setState({ language: lang, routeComponent: renderResult });
  // }
  // themeChanged(theme) {
  //   this.setState({ theme });
  // }

  versionLoaded(versionInfo) {
    let routeToLoad;
    // let routeToLoad = timpsRoutes;
    iconCustomizer.loadVersion(versionInfo);
    if (versionInfo.isLAMPDeprecated()) routeToLoad = lampRoutes;
    if (versionInfo.isReVAMP()) {
      routeToLoad = [...liteRoutes];
      localStorage.setItem("theme", "retro");
      updateThemeColors("lite");
    } else if (versionInfo.isEUtility()) {
      routeToLoad = timpsRoutes;
      localStorage.setItem("theme", "electric");
      //require("../../utils/electric-color.css");
      updateThemeColors("electric");
    } else {
      routeToLoad = timpsRoutes;
      localStorage.setItem("theme", "retro");
      updateThemeColors("retro");
    }
    //let rc = routeToLoad.map((route, index) => {return <Route key={route.path} path={route.path} component={route.component} />;});
    this.setState({ applicationType: versionInfo.getApplicationType(), routesToLoad: routeToLoad });

    tabTitle();

    const fi = document.getElementById("favicon");
    if (versionInfo.isSITE()) {
      fi.href = "/SCIM_Tab_Logo.png";
    } else if (versionInfo.isReVAMP()) {
      fi.href = "/LAMP_TITLE.png";
    } else {
      versionInfo.isEUtility()
        ? (fi.href = "EUIS_Tab_Logo.png")
        : versionInfo.isBridge()
          ? (fi.href = "/BIS_Tab_Logo.png")
          : versionInfo.isTIMPS()
            ? (fi.href = "/TIMPS_Tab_Logo.png")
            : "";
    }

    this.resize();
  }

  render() {
    // const isLoggedOnCheck = this.loggedInUser()
    // if (!isLoggedOnCheck) {
    //   if (this.props.history.location.pathname !== '/login') {
    //     this.props.history.push('/login')
    //   }
    // }

    let routeComponent = this.state.routesToLoad.map((route, index) => {
      return <Route key={route.path} path={route.path} component={route.component} />;
    });

    const { topBarVisible, sidebarVisible, userLoggedOn, user } = this.state;
    const loginScreen = (
      <div className="App-container">
        <div className="App-login">
          <LoginContainer />
        </div>
      </div>
    );
    // console.log("routeComponent")
    // console.log(routeComponent)
    const width = window.innerWidth;
    let switchComp = (
      <Switch>
        <Route path="/microsoftRedirect" component={MicrosoftRedirectPage} />
        <Route path="/login" component={LoginContainer} />
        <Route path="/logout" component={Logout} />
        <Route path="/diagnostics" component={Diagnostics} />
        <Route path="/dev" component={Basicform} />
        <Route path="/forgotPassword" component={ForgotPassword} />
        {/* <Route path="/confirmreset/:id" component={VerifyResetPass} /> */}
        <Route path="/confirmreset/:token" component={ResetPassword} />
        {routeComponent}
      </Switch>
    );
    return (
      <React.Fragment>
        <VersionManager loadCallback={this.versionLoaded} />
        {!versionInfo.isLoaded() && <MainPageSpinner />}
        {versionInfo.isLoaded() && (
          <div className={"App " + this.state.theme}>
            <SocketIO />
            {topBarVisible && (
              <TopBar
                sidebarToggle={this.sidebarToggle}
                hideToolTip={this.state.hideToolTip}
                toggleRight={this.toggleRight}
                isFra={this.state.isFra}
                tempUser={this.state.tempUser}
                expireSession={this.expireSession}
              />
            )}
            {this.isLoggedOn() && this.state.showSideNav && !this.isApp() && this.state.applicationType && (
              <SideNavBar
                hideNav={window.innerWidth}
                textDisplay={this.state.textDisplay}
                sidebarWidth={this.state.sidebarWidth}
                sideNavDispaly={this.state.sideNavDispaly}
                hamBurgerVisible={this.state.hamBurgerVisible}
                hideToolTip={this.state.hideToolTip}
                applicationType={this.state.applicationType}
              />
            )}

            <div
              id="mainContent"
              className={this.isApp ? "main-content-area is-app scrollbarHor" : "main-content-area scrollbarHor"}
              style={{
                position: "absolute",
                left: this.isApp() ? 0 : this.state.mainSectionLeft,
                top: "70px",
                right: 0,
                bottom: 0,
                ...(width < 315 && this.state.tempUser && { top: "130px" }),
              }}
            >
              {switchComp}
            </div>
            {/* !userLoggedOn && loginScreen */}
            {/* userLoggedOn && <DashBoard/> */}
            <FloatingNavigation></FloatingNavigation>
          </div>
        )}
        {!this.state.isFra && versionInfo.isLoaded() && (
          <NotificationBar rightValue={this.state.rightValue} toggleRight={this.toggleRight} />
        )}
        {!this.state.isFra && versionInfo.isLoaded() && (
          <div
            className="modal-cover"
            style={{
              visibility: this.state.rightValue === "-20%" ? "hidden" : "visible",
              top: this.state.rightValue === "-20%" ? "100vh" : "0px",
            }}
            onClick={this.toggleRight}
          />
        )}
      </React.Fragment>
    );
  }
}

const DashBoard = () => (
  <div>
    <h2>Dashboard Component </h2>
  </div>
);
let MainPageContainer = CRUDFunction(
  MainPage,
  "MainPage",
  {
    create: false,
    update: false,
    read: false,
    delete: false,
    others: {
      getUserFromToken: getUserFromToken,
    },
  },
  {
    userReducer: {
      tempUser: {},
    },
  },
  ["userReducer"],
);
export default withRouter(MainPageContainer);



// WEBPACK FOOTER //
// ./src/components/MainPage/MainPage.jsx